<template>
  <div class="flex flex-col gap-2">
    <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" for="towndistrict">Område</label>
    <multiselect
      v-model="value__"
      :options="availableTownDisctricts"
      @update:modelValue="change"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :searchable="true"
      deselect-label=""
      select-label=""
      selected-label="Vald"
      placeholder="Alla"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { forEach, map } from 'lodash';

export default {
  components: { Multiselect },
  props: {
    modelValue: {
      type: Array,
      required: false,
    },
    searchtype: {
      type: String,
      required: false,
    },
    allObjects: {
      required: false,
    },
  },
  data() {
    return {
      countedDistricts: [],

      /**
       * Inskickat prop får inte manipuleras. Därför klonas den (eller va gör data() med den?)
       */
      value__: this.modelValue,
    };
  },
  computed: {
    availableTownDisctricts: function () {
      if (this.searchtype == 'studentapartment')
        return this.$store.getters.config.neighbourhoodsStudent;
      return this.$store.getters.config.neighbourhoods;
    },
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     *
     * I fallet med denna, som använder Multiselect, är det lite special för att det ska funka.
     */
    modelValue: {
      immediate: true,
      handler() {
        if (this.modelValue) this.value__ = [...this.modelValue];
      },
      deep: true,
    },

    availableTownDisctricts: {
      handler(oldValue, newValue) {
        this.setFilterCount();
      },
    },
    allObjects: function (newVal, oldVal) {
      // watch it
      this.setFilterCount();
    },
  },
  methods: {
    change() {
      this.$emit(
        'update:modelValue',
        map(this.value__, (townDisctrict) => {
          return townDisctrict;
        }),
      );
    },
    setFilterCount() {
      this.countedDistricts = [];
      forEach(this.availableTownDisctricts, (obj) => {
        let c = 0;
        forEach(this.allObjects, (o) => {
          if (o.neighbourhood && o.neighbourhood.toLowerCase() == obj.toLowerCase()) c++;
        });
        let numitems = c ? c : 0;
        this.countedDistricts.push(obj + ' (' + numitems + ')');
      });
    },
  },

  created() {
    this.setFilterCount();
  },
};
</script>
